import styled from 'styled-components';

export const ListPlaceholder = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 15px;
  color: ${({ theme }) => theme.color.baliHai};
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;
